<template>
    <q-btn round :class='["q-ma-sm", valueInternal]' @click="toggleGroup()" :readonly="true">{{shortName}}</q-btn>
</template>

<script>
    export default {
        name: 'GroupSwitcher',
        props: ['value'],
        data() {
            return {
                valueInternal: '',
            }
        },
        mounted () {
            this.valueInternal = this.value || ''
        },
        watch: {
            value () {
                this.valueInternal = this.value
            }
        },
        methods: {
            toggleGroup () {
                switch (this.valueInternal) {
                    case '':
                        this.valueInternal = 'junior'
                        break
                    case 'junior':
                        this.valueInternal = 'senior'
                        break
                    case 'senior':
                        this.valueInternal = ''
                        break
                    default:
                        this.valueInternal = ''

                }

                this.$emit('change', this.valueInternal)
            },
        },
        computed: {
            shortName () {
                return (this.valueInternal || '').substr(0,3);
            }
        }
    }
</script>

<style scoped lang="scss">
    .junior {
        background-color: green;
        color: #fff;
    }

    .senior {
        background-color: orange;
        color: #fff;
    }

</style>